<template>
  <div>

    <portal to="toolbar-title"> Κτήρια</portal>
    <portal to="toolbar-actions">
    </portal>

    <single-page>
      <template v-slot:toolbar-title>
        Προβολή Κτήριων
      </template>
      <template v-slot:toolbar-items>
        <v-btn-toggle v-model="viewMode">
          <v-btn value="grid" icon>
            <v-icon>mdi-grid</v-icon>
          </v-btn>
          <v-btn value="table" icon>
            <v-icon>mdi-table</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>

      <template v-slot:main-sidebar>
        <filters module-name="BuildingsHandler"/>
      </template>

      <template v-slot:main-content>
        <v-text-field  flat hide-details append-icon="mdi-search" label="Αναζήτηση" v-model="search"></v-text-field>
        <active-filters module-name="BuildingsHandler"/>
        <v-data-iterator hide-default-footer :search="search" :items="data" v-if="viewMode==='grid'">
          <template v-slot:default="{items}">
            <v-row>
              <v-col lg=4 v-for="building in items">
                <v-card
                >
                  <v-toolbar dense flat>
                    <v-toolbar-title>
                      {{ building.BranchAddress }}, {{ building.BranchAreaName }}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-list >
                    <v-list-item>
                      <v-list-item-action>
                        <v-icon>mdi-city</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ building.BranchDimosName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Δήμος
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-icon>mdi-briefcase</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ building.PartnerBrandName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Πελάτης
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="userDetails.Allows.ShowDeptsMoves || userDetails.Allows.ShowDepts">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ building.ProjectCount }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <wnl-text>Ανυψωτικά</wnl-text>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ building.PosoXreosis | fixed }}€
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Χρέωση / Μήνα
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-card-actions>
                    <v-btn color="primary" text @click="rowClick(building)"> ΠΕΡΙΣΣΟΤΕΡΑ</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="userDetails.Allows.ShowDeptsMoves" icon v-tooltip="'Αναλυτικές Κινήσεις πελάτη '"
                           :to="'/building/'+building.Branch_ID+'/partnerMoves'">
                      <v-icon>mdi-compare-horizontal</v-icon>
                    </v-btn>
                    <v-btn icon v-tooltip="$unitText('Ανυψωτικά')+'Κτηρίου'"
                           :to="'/lift/'+building.Projects[0].Project_ID">
                      <v-icon>mdi-elevator</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <v-card v-if="viewMode==='table'">
          <v-card-text>
            <v-data-table :search="search"  @click:row="rowClick" :headers="headers" :items="data"
                          disable-pagination
                          hide-default-footer fixed-header height="65vh" mobile-breakpoint="0">
              <template v-slot:item.PosoXreosis="{item}">
                {{ item.PosoXreosis | fixed }}€
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </single-page>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import store from '../../../store';
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import Filters from "../../../wl-datagrid-handler/Filters";
import ActiveFilters from "../../../wl-datagrid-handler/ActiveFilters";
import EventCard from "../../Events/components/EventCard";
import BuildingCard from "../components/BuildingCard";
import FiltersModal from "../../../wl-datagrid-handler/FiltersModal";
import SinglePage from "@/components/templates/SinglePage";
import WnlText from "@/wl-unit-text/WnlText";

export default {
  name: "Buildings",
  components: {WnlText, SinglePage, FiltersModal, BuildingCard, ActiveFilters, Filters},
  data: () => ({
    buildingDialog: false,
    activeBuilding: null,
    headers: [
      {
        text: 'Διεύθυνση',
        value: 'BranchAddress',
        filterable: true,
      },
      {
        text: 'Περιοχή',
        value: 'BranchAreaName',
        filterable: true,
        width: "100"
      },
      {
        text: 'Δήμος',
        value: 'BranchDimosName',
        filterable: true,
        width: "100"
      },
      {
        text: 'Πελάτης',
        value: 'PartnerFullName',
        filterable: true,
      },
      {
        text: 'Ποσό Χρέωσης',
        value: 'PosoXreosis',
        filterable: true,
        width: "100"
      },
      {
        text: '# Ανυψ.',
        value: 'ProjectCount',
        filterable: true,
        width: "100"
      },
    ],
    viewMode: 'table',
    search: null
  }),
  beforeCreate() {
    store.registerModule('BuildingsHandler', dataGridHandler);
  },

  beforeDestroy() {
    this.$store.unregisterModule('BuildingsHandler')
  },
  created() {
    this.showLoading();
    this.viewMode = this.isMobile ? 'grid' : 'table';
    this.getPartnerDetails().then(() => {
      this.hideLoading();
      this.setBuildings();
    })
  },
  methods: {
    setBuildings() {
      this.setData(this.branches);
      this.createFilters([
        {key: 'BranchDimosName', name: 'Δήμος'},
        {key: 'BranchAreaName', name: 'Περιοχή'},
        {key: 'PartnerFullName', name: 'Πελάτες'}
      ])
    },
    ...mapActions([
      "getPartnerDetails"
    ]),
    ...mapMutations([
      "showLoading",
      "hideLoading",
    ]),
    ...mapMutations('BuildingsHandler', [
      "clearAllFilters",
      "clearFilter",
      "setData",
      "addFilter",
      "createFilters",
    ]),
    rowClick(building) {
      this.$router.push({path: '/building/' + building.Branch_ID, params: {building: building}});
    }
  },
  computed: {
    ...mapGetters([
      "branches",
      "isMobile",
      "userDetails"
    ]),
    ...mapGetters('BuildingsHandler', [
      "data"
    ])
  }
}
</script>

<style scoped>

</style>
